import type { BackendRouteDefinition } from '../types';

/**
 * Kept isolated so the Phase 3 onboarding migration can flip this route's
 * transport without touching shared admin route tables.
 */
export const createFirmOnboardingFormsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/onboarding/forms',
  body: (requestData) => requestData,
} as const satisfies BackendRouteDefinition;
